export default {
  // 配置首页不可关闭
  isFirstPage: false,
  fistPage: {
    label: '数据概览',
    value: '/home',
    params: {},
    query: {},
    group: [],
    close: false,
  },
};
